var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDiskSolidDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64,32A64.06,64.06,0,0,0,0,96V416a64.06,64.06,0,0,0,64,64H384a64.06,64.06,0,0,0,64-64V173.3A64,64,0,0,0,429.3,128L352,50.7A64,64,0,0,0,306.7,32Zm0,96A32,32,0,0,1,96,96H288a32,32,0,0,1,32,32v64a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32ZM224,288a64,64,0,1,1-64,64A64,64,0,0,1,224,288Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskSolidDark);
export default __webpack_public_path__ + "static/media/floppy-disk-solid-dark.daeb605b08c7ef35fdfedc8f6208f7d9.svg";
export { ForwardRef as ReactComponent };